import { createFileRoute } from "@tanstack/react-router";
import { PaymentsTab } from "../../../companies/payments/PaymentsTab";

export const Route = createFileRoute("/firmen/$companyId/zahlungen")({
  loader: async ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.billing.taxAdvisoryPayments.listForCompany.queryOptions({
        companyId,
      })
    );
  },
  component: ZahlungenRoute,
});

function ZahlungenRoute() {
  const { companyId } = Route.useParams();
  return <PaymentsTab companyId={companyId} />;
}
